/**
 * Paths extracted from Wikimedia Commons Kit_blank.svg (public domain).
 * @see https://commons.wikimedia.org/wiki/File:Kit_blank.svg
 */
export const KIT_VIEWBOX = '0 0 100 135';

export const KIT_SHIRT_TRANSFORM = 'translate(31,-5)';

export const KIT_SHIRT_PATH =
  'M -0.5,58.5 L -0.5,31.5 L -6,37 L -19,24 L -0.5,5.5 L 9.656,5.5 C 14.359984,7.5600799 16.72203,8.5842032 19.074651,8.5812448 C 21.427273,8.5782865 23.770718,7.5482466 28.469,5.5 L 38.5,5.5 L 57,24 L 44,37 L 38.5,31.5 L 38.5,58.5 L -0.5,58.5';

export const KIT_SHORTS_PATH =
  'M 31.218752,48 L 68.781331,48 L 74.500103,88.5 L 53.500059,88.5 L 50.500053,75 L 47.500046,88.5 L 25.5,88.5 L 31.218752,48 z';

export const KIT_SOCKS_PATH =
  'M 69.5,136 L 56.5,136 L 56.5,102.5 L 71.5,102.5 L 69.5,136 z M 44.5,136 L 31.5,136 L 29.5,102.5 L 44.5,102.5 L 44.5,136 z';

/** Pattern bounding boxes in the 100×135 kit coordinate space. */
export const KIT_SHIRT_PATTERN_BOX = { x: -19, y: 5.5, w: 76, h: 53 };
export const KIT_SHORTS_PATTERN_BOX = { x: 25.5, y: 48, w: 49, h: 40.5 };
export const KIT_SOCKS_PATTERN_BOX = { x: 29.5, y: 102.5, w: 42, h: 33.5 };

export const KIT_STROKE = {
  stroke: '#000000',
  strokeWidth: 1,
  strokeLinejoin: 'round' as const,
  strokeLinecap: 'square' as const,
};
